import { render, staticRenderFns } from "./foor-style-6.vue?vue&type=template&id=4927f1fc&scoped=true"
import script from "./foor-style-6.vue?vue&type=script&lang=js"
export * from "./foor-style-6.vue?vue&type=script&lang=js"
import style0 from "./foor-style-6.vue?vue&type=style&index=0&id=4927f1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4927f1fc",
  null
  
)

export default component.exports